angular.module('dpw.directives')
    .directive('dpwExportPopup', [function () {
        return {
            restrict: 'A',
            scope: true,
            controller: ['$scope', function ($scope) {
                this.submit = function () {
                    var form = $('.dpw-export-popup form');
                    if (!form.valid()) {
                        return;
                    }
                    $scope.callback();
                };
            }],
            controllerAs: 'ctrl',
            templateUrl: 'dpw-export-popup.html'
        };
    }]);
